import { Cloud } from '@mui/icons-material';
import { Box, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Sub } from '../components/Sub.tsx';
import { formattedDecimal } from '../utils.ts';

const usageTooltips: Record<string, string> = {
  Conventional:
    'Conventional alternative builds are what you would traditionally use without consideration of carbon impact.',
  'Low Carbon':
    'Low Carbon builds do not use any components that consume natural gas.',
  'Net Zero':
    'Zero Carbon builds do not use any components that consume natural gas and only use low Energy Demand components.',
};

interface DecarbHubTileHeaderProps {
  usage: string;
  annualEmissions: number;
}

export const DecarbHubTileHeader: React.FC<DecarbHubTileHeaderProps> = ({
  usage,
  annualEmissions,
}) => {
  return (
    <Paper
      sx={{
        bgcolor: 'primary.dark',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        p: 3,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        textTransform: 'uppercase',
      }}
    >
      <Tooltip title={usageTooltips[usage] ?? ''} arrow placement='top'>
        <Typography variant={'h5'} sx={{ cursor: 'help' }}>
          {usage}
        </Typography>
      </Tooltip>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Cloud />
        <Typography variant={'subtitle1'}>Emissions</Typography>
        <Typography
          variant={'subtitle1'}
          sx={{
            textTransform: 'none',
          }}
        >
          {formattedDecimal(annualEmissions)} tCO
          <Sub variant={'inherit'}>2</Sub>e
        </Typography>
      </Box>
    </Paper>
  );
};
